import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { OrderType } from 'models'
import { styled } from '@mui/material/styles'
import { KToggleButton } from 'components/core/KButton'
import { useCurrentStore } from 'hooks'

interface OrderTypeSelectProps {
  value?: OrderType
  onChange?: (value: OrderType) => void
}

const TB = styled(KToggleButton)(() => ({
  width: '33.33%',
  fontWeight: 500,
}))

export const OrderTypeSelect = ({ value, onChange }: OrderTypeSelectProps) => {
  const { t } = useTranslation()
  const { store } = useCurrentStore()

  const orderTypes = [
    {
      value: 'delivery',
      label: t('Delivery'),
      hide: store?.accept_delivery === false,
    },
    {
      value: 'pickup',
      label: t('Pickup'),
      hide: store?.accept_pickup === false,
    },
    {
      value: 'dinein',
      label: t('Dine-in'),
      hide: store?.accept_dinein === false,
    },
  ]
  return (
    <Stack sx={{ flexDirection: 'row', gap: 2, width: '100%' }}>
      {orderTypes
        .filter((x) => !x.hide)
        .map(({ label, value: v }) => (
          <TB
            key={v}
            onClick={() => onChange?.(v as OrderType)}
            variant={value === v ? 'primary' : 'secondary'}
            size="medium"
          >
            {label}
          </TB>
        ))}
    </Stack>
  )
}
